import type { PayPeriodStatus } from "@crewledger/shared/schemas";
import { StatusBadge } from "@/components/design";
import type { WorkflowStatus } from "@/lib/design-tokens";

function mapStatus(status: PayPeriodStatus): WorkflowStatus {
  switch (status) {
    case "OPEN":
      return "Draft";
    case "IN_REVIEW":
      return "Submitted";
    case "APPROVED":
      return "Approved";
    case "LOCKED":
      return "Locked";
    case "EXPORTED":
      return "Exported";
    default:
      return "Draft";
  }
}

export function PayPeriodStatusBadge({ status }: { status: PayPeriodStatus }) {
  return <StatusBadge status={mapStatus(status)} />;
}

export function payPeriodStatusLabel(status: PayPeriodStatus): string {
  switch (status) {
    case "OPEN":
      return "Open";
    case "IN_REVIEW":
      return "In Review";
    case "APPROVED":
      return "Approved";
    case "LOCKED":
      return "Locked";
    case "EXPORTED":
      return "Exported";
    default:
      return status;
  }
}
